// extracted by mini-css-extract-plugin
export default {"App":"App_App__d6742","App-logo":"App_App-logo__VfFdW","App-logo-spin":"App_App-logo-spin__cRvCf","App-header":"App_App-header__MJcIG","App-link":"App_App-link__PylfD"};